// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ApdWo{height:100%;display:flex;flex-direction:column}.eiQ9h{position:sticky;top:0;z-index:1;padding:24px 24px 16px;width:100%;display:flex;align-items:center;gap:12px;box-sizing:border-box}.bbVGW{flex:1 1 auto;min-width:0}.pwlcq,.eeAgM{width:40px;height:40px;flex-shrink:0;display:flex;align-items:center;justify-content:center}._1gDSI{height:6px;width:100%}.TpPW3{flex:1;overflow-y:auto;padding:8px 0 32px;display:flex;justify-content:center;align-items:safe center}.zjxZG{position:sticky;bottom:0;z-index:1;padding:16px 24px 32px;background:#fff}.loLHv{min-width:160px}@media(max-width: 640px){.TpPW3{align-items:flex-start}.zjxZG{padding:16px 24px 24px}.loLHv{flex:1;min-width:0}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ApdWo`,
	"header": `eiQ9h`,
	"progressBarContainer": `bbVGW`,
	"backSlot": `pwlcq`,
	"closeSlot": `eeAgM`,
	"progressBar": `_1gDSI`,
	"content": `TpPW3`,
	"footer": `zjxZG`,
	"continueButton": `loLHv`
};
export default ___CSS_LOADER_EXPORT___;
